module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--heading"
  }, [_vm._v("Tender Bulletin")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.body)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.page.section_1.button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.button_text))]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.page.section_1.additional_button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.additional_button_text))])], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.page.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.procurement), function(procurement, index) {
    return _c('sk-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', {
      staticClass: "static-info--heading"
    }, [_vm._v("Tender Invitation")])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_number))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender publication date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_publication_date))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender description")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.tender_description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Sk Procurement representive")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_name))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_email))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Date of modification of tender invitation")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.modification_date)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender collection time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_collection_time))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Physical Address for tender response")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.physical_address)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Special conditions (if any)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.special_conditions))])])])], 1)
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01413c78","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procurement-tabs/tender-invitation/tender-invitation.vue
// module id = 947
// module chunks = 0